import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// react-snap pre-renders each route into a static HTML file at build time.
// When the user lands on that HTML, hydrate instead of recreating from scratch
// so the SEO content (titles, meta, JSON-LD) remains in the head and the page
// is interactive without a flash of empty content.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, tree);
} else {
  const root = ReactDOM.createRoot(container);
  root.render(tree);
}
